var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321316175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9507 11.3715C11.6314 11.3715 11.3705 11.6315 11.3705 11.9517V26.0521C11.3705 26.3713 11.6305 26.6313 11.9507 26.6313H26.0511C26.3704 26.6313 26.6312 26.3713 26.6312 26.0521V11.9517C26.6312 11.6324 26.3713 11.3725 26.0511 11.3725H11.9507V11.3715ZM26.0511 27.1112H11.9507C11.3657 27.1112 10.8906 26.6361 10.8906 26.0511V11.9507C10.8906 11.3666 11.3657 10.8906 11.9507 10.8906H26.0511C26.6352 10.8906 27.1112 11.3657 27.1112 11.9507V26.0511C27.1112 26.6352 26.6351 27.1112 26.0511 27.1112Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2633 13.0102C13.1251 13.0102 13.0112 13.1232 13.0112 13.2624V24.7394C13.0112 24.8786 13.1241 24.9915 13.2623 24.9915H24.7393C24.8776 24.9915 24.9914 24.8786 24.9914 24.7403V13.2633C24.9914 13.1241 24.8785 13.0112 24.7393 13.0112H13.2623L13.2633 13.0102ZM24.7403 25.4714H13.2633C12.8593 25.4714 12.5312 25.1433 12.5312 24.7393V13.2623C12.5312 12.8583 12.8593 12.5303 13.2633 12.5303H24.7403C25.1433 12.5303 25.4723 12.8583 25.4723 13.2623V24.7393C25.4723 25.1433 25.1433 25.4714 24.7403 25.4714Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5451 14.8753C22.4127 14.8753 22.3047 14.7682 22.3047 14.6349V12.7697C22.3047 12.6373 22.4118 12.5293 22.5451 12.5293C22.6785 12.5293 22.7856 12.6364 22.7856 12.7697V14.6349C22.7856 14.7673 22.6785 14.8753 22.5451 14.8753Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5447 14.8754C22.2702 14.8754 22.0473 15.0983 22.0473 15.3728C22.0473 15.6474 22.2702 15.8703 22.5447 15.8703C22.8192 15.8703 23.0422 15.6474 23.0422 15.3728C23.0422 15.0983 22.8192 14.8754 22.5447 14.8754ZM22.5447 16.3512C22.0054 16.3512 21.5664 15.9121 21.5664 15.3728C21.5664 14.8336 22.0054 14.3945 22.5438 14.3945C23.0831 14.3945 23.5221 14.8336 23.5221 15.3728C23.5221 15.9121 23.0831 16.3512 22.5438 16.3512H22.5447Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6368 16.2367H12.7717C12.6393 16.2367 12.5312 16.1297 12.5312 15.9963C12.5312 15.8639 12.6393 15.7559 12.7717 15.7559H14.6368C14.7692 15.7559 14.8773 15.8629 14.8773 15.9963C14.8773 16.1287 14.7702 16.2367 14.6368 16.2367Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3728 15.4985C15.0983 15.4985 14.8744 15.7214 14.8744 15.9959C14.8744 16.2704 15.0983 16.4933 15.3719 16.4933C15.6464 16.4933 15.8693 16.2704 15.8693 15.9959C15.8693 15.7214 15.6454 15.4985 15.3719 15.4985H15.3728ZM15.3728 16.9742C14.8336 16.9742 14.3945 16.5352 14.3945 15.9959C14.3945 15.4566 14.8336 15.0176 15.3728 15.0176C15.9121 15.0176 16.3512 15.4566 16.3512 15.9959C16.3512 16.5352 15.9121 16.9742 15.3728 16.9742Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4816 20.2026H12.7717C12.6393 20.2026 12.5312 20.0955 12.5312 19.9621C12.5312 19.8297 12.6393 19.7217 12.7717 19.7217H16.4816C16.614 19.7217 16.722 19.8288 16.722 19.9621C16.722 20.0945 16.6149 20.2026 16.4816 20.2026Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2195 19.4643C16.945 19.4643 16.7221 19.6872 16.7221 19.9617C16.7221 20.2362 16.945 20.4592 17.2195 20.4592C17.4941 20.4592 17.717 20.2362 17.717 19.9617C17.717 19.6872 17.494 19.4643 17.2195 19.4643ZM17.2195 20.94C16.6802 20.94 16.2422 20.501 16.2422 19.9617C16.2422 19.4224 16.6812 18.9834 17.2195 18.9834C17.7588 18.9834 18.1979 19.4224 18.1979 19.9617C18.1979 20.501 17.7588 20.94 17.2195 20.94Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2306 19.2416H23.3654C23.2331 19.2416 23.125 19.1345 23.125 19.0012C23.125 18.8688 23.2321 18.7607 23.3654 18.7607H25.2306C25.363 18.7607 25.471 18.8688 25.471 19.0012C25.471 19.1336 25.3639 19.2416 25.2306 19.2416Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6268 18.5033C22.3522 18.5033 22.1284 18.7263 22.1284 19.0008C22.1284 19.2753 22.3513 19.4982 22.6258 19.4982C22.9003 19.4982 23.1232 19.2753 23.1232 19.0008C23.1232 18.7263 22.9003 18.5033 22.6258 18.5033H22.6268ZM22.6268 19.9791C22.0875 19.9791 21.6484 19.5401 21.6484 19.0008C21.6484 18.4615 22.0875 18.0225 22.6268 18.0225C23.1661 18.0225 23.6041 18.4615 23.6041 19.0008C23.6041 19.5401 23.1651 19.9791 22.6268 19.9791Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6701 25.471C21.5377 25.471 21.4297 25.3639 21.4297 25.2306V23.3654C21.4297 23.2331 21.5368 23.125 21.6701 23.125C21.8025 23.125 21.9106 23.2321 21.9106 23.3654V25.2306C21.9106 25.363 21.8025 25.471 21.6701 25.471Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6697 22.1303C21.3952 22.1303 21.1713 22.3532 21.1713 22.6277C21.1713 22.9023 21.3942 23.1252 21.6688 23.1252C21.9433 23.1252 22.1662 22.9022 22.1662 22.6277C22.1662 22.3532 21.9433 22.1303 21.6688 22.1303H21.6697ZM21.6697 23.6061C21.1304 23.6061 20.6914 23.167 20.6914 22.6277C20.6914 22.0884 21.1304 21.6494 21.6697 21.6494C22.209 21.6494 22.6471 22.0884 22.6471 22.6277C22.6471 23.167 22.209 23.6061 21.6697 23.6061Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3342 25.471C16.2018 25.471 16.0938 25.3639 16.0938 25.2306V23.3654C16.0938 23.2331 16.2008 23.125 16.3342 23.125C16.4666 23.125 16.5746 23.2321 16.5746 23.3654V25.2306C16.5746 25.363 16.4666 25.471 16.3342 25.471Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3338 22.1303C16.0593 22.1303 15.8354 22.3532 15.8354 22.6277C15.8354 22.9023 16.0593 23.1252 16.3328 23.1252C16.6073 23.1252 16.8302 22.9022 16.8302 22.6277C16.8302 22.3532 16.6064 22.1303 16.3328 22.1303H16.3338ZM16.3338 23.6061C15.7945 23.6061 15.3555 23.167 15.3555 22.6277C15.3555 22.0884 15.7945 21.6494 16.3338 21.6494C16.8731 21.6494 17.3121 22.0884 17.3121 22.6277C17.3121 23.167 16.8731 23.6061 16.3338 23.6061Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7756 14.8753C18.6432 14.8753 18.5352 14.7682 18.5352 14.6349V12.7697C18.5352 12.6373 18.6422 12.5293 18.7756 12.5293C18.908 12.5293 19.016 12.6364 19.016 12.7697V14.6349C19.016 14.7673 18.908 14.8753 18.7756 14.8753Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7752 14.8754C18.5007 14.8754 18.2768 15.0983 18.2768 15.3728C18.2768 15.6474 18.4997 15.8703 18.7742 15.8703C19.0487 15.8703 19.2717 15.6474 19.2717 15.3728C19.2717 15.0983 19.0487 14.8754 18.7742 14.8754H18.7752ZM18.7752 16.3512C18.2359 16.3512 17.7969 15.9121 17.7969 15.3728C17.7969 14.8336 18.2359 14.3945 18.7752 14.3945C19.3145 14.3945 19.7525 14.8336 19.7525 15.3728C19.7525 15.9121 19.3135 16.3512 18.7752 16.3512Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2795 11.3711C14.1471 11.3711 14.0391 11.264 14.0391 11.1307V8.24044C14.0391 8.10805 14.1461 8 14.2795 8C14.4119 8 14.5199 8.10708 14.5199 8.24044V11.1307C14.5199 11.2631 14.4119 11.3711 14.2795 11.3711Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4279 11.3711C17.2956 11.3711 17.1875 11.264 17.1875 11.1307V8.24044C17.1875 8.10805 17.2946 8 17.4279 8C17.5613 8 17.6684 8.10708 17.6684 8.24044V11.1307C17.6684 11.2631 17.5613 11.3711 17.4279 11.3711Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5725 11.3711C20.4401 11.3711 20.332 11.264 20.332 11.1307V8.24044C20.332 8.10805 20.4391 8 20.5725 8C20.7049 8 20.8129 8.10708 20.8129 8.24044V11.1307C20.8129 11.2631 20.7049 11.3711 20.5725 11.3711Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7209 11.3711C23.5885 11.3711 23.4805 11.264 23.4805 11.1307V8.24044C23.4805 8.10805 23.5875 8 23.7209 8C23.8533 8 23.9613 8.10708 23.9613 8.24044V11.1307C23.9613 11.2631 23.8533 11.3711 23.7209 11.3711Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2795 30.001C14.1471 30.001 14.0391 29.8939 14.0391 29.7606V26.8703C14.0391 26.7379 14.1461 26.6299 14.2795 26.6299C14.4119 26.6299 14.5199 26.737 14.5199 26.8703V29.7606C14.5199 29.893 14.4119 30.001 14.2795 30.001Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4279 30.001C17.2956 30.001 17.1875 29.8939 17.1875 29.7606V26.8703C17.1875 26.7379 17.2946 26.6299 17.4279 26.6299C17.5613 26.6299 17.6684 26.737 17.6684 26.8703V29.7606C17.6684 29.893 17.5613 30.001 17.4279 30.001Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5725 30.001C20.4401 30.001 20.332 29.8939 20.332 29.7606V26.8703C20.332 26.7379 20.4391 26.6299 20.5725 26.6299C20.7049 26.6299 20.8129 26.737 20.8129 26.8703V29.7606C20.8129 29.893 20.7049 30.001 20.5725 30.001Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7209 30.001C23.5885 30.001 23.4805 29.8939 23.4805 29.7606V26.8703C23.4805 26.7379 23.5875 26.6299 23.7209 26.6299C23.8533 26.6299 23.9613 26.737 23.9613 26.8703V29.7606C23.9613 29.893 23.8533 30.001 23.7209 30.001Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7586 24.2289H26.8693C26.737 24.2289 26.6289 24.1218 26.6289 23.9885C26.6289 23.8561 26.737 23.748 26.8693 23.748H29.7586C29.892 23.748 29.999 23.8551 29.999 23.9885C29.999 24.1209 29.892 24.2289 29.7586 24.2289Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7586 21.0815H26.8693C26.737 21.0815 26.6289 20.9744 26.6289 20.841C26.6289 20.7086 26.737 20.6006 26.8693 20.6006H29.7586C29.892 20.6006 29.999 20.7086 29.999 20.841C29.999 20.9734 29.892 21.0815 29.7586 21.0815Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7586 17.933H26.8693C26.737 17.933 26.6289 17.8259 26.6289 17.6926C26.6289 17.5602 26.737 17.4521 26.8693 17.4521H29.7586C29.892 17.4521 29.999 17.5592 29.999 17.6926C29.999 17.825 29.892 17.933 29.7586 17.933Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7586 14.7865H26.8693C26.737 14.7865 26.6289 14.6795 26.6289 14.5461C26.6289 14.4137 26.737 14.3057 26.8693 14.3057H29.7586C29.892 14.3057 29.999 14.4137 29.999 14.5461C29.999 14.6785 29.892 14.7865 29.7586 14.7865Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1307 24.2289H8.24044C8.10805 24.2289 8 24.1218 8 23.9885C8 23.8561 8.10708 23.748 8.24044 23.748H11.1307C11.2631 23.748 11.3711 23.8551 11.3711 23.9885C11.3711 24.1209 11.2641 24.2289 11.1307 24.2289Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1307 21.0815H8.24044C8.10805 21.0815 8 20.9744 8 20.841C8 20.7086 8.10708 20.6006 8.24044 20.6006H11.1307C11.2631 20.6006 11.3711 20.7086 11.3711 20.841C11.3711 20.9734 11.2641 21.0815 11.1307 21.0815Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1307 17.933H8.24044C8.10805 17.933 8 17.8259 8 17.6926C8 17.5602 8.10708 17.4521 8.24044 17.4521H11.1307C11.2631 17.4521 11.3711 17.5592 11.3711 17.6926C11.3711 17.825 11.2641 17.933 11.1307 17.933Z",
    fill: "#1D53E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1307 14.7865H8.24044C8.10805 14.7865 8 14.6795 8 14.5461C8 14.4137 8.10708 14.3057 8.24044 14.3057H11.1307C11.2631 14.3057 11.3711 14.4137 11.3711 14.5461C11.3711 14.6785 11.2641 14.7865 11.1307 14.7865Z",
    fill: "#1D53E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmd);
export default __webpack_public_path__ + "static/media/AMD.76291d54e6e35aaa3b4db62acc15eba7.svg";
export { ForwardRef as ReactComponent };